/**
 * Authentication service — wraps `/api/auth/*` endpoints.
 *
 * Pages should consume these functions instead of touching `api` directly so the
 * transport layer can change without rippling through the UI.
 *
 * @module services/authService
 */
import { api } from "../lib/api";
// eslint-disable-next-line no-unused-vars
import {} from "./types";

export const authService = {
  /** @returns {Promise<import("./types").UserMe>} */
  me: () => api.get("/auth/me").then((r) => r.data),

  /** @returns {Promise<import("./types").AuthResponse>} */
  login: (email, password, extra = {}) =>
    api.post("/auth/login", { email, password, ...extra }).then((r) => r.data),

  /** @returns {Promise<import("./types").AuthResponse>} */
  register: (email, password, extra = {}) =>
    api.post("/auth/register", { email, password, ...extra }).then((r) => r.data),

  /** iter-169l — Email verification flow */
  resendVerification: (email) =>
    api.post("/auth/resend-verification", { email }).then((r) => r.data),
  updatePendingEmail: (current_email, new_email) =>
    api.post("/auth/update-pending-email", { current_email, new_email }).then((r) => r.data),
  verifyEmail: (token) =>
    api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`).then((r) => r.data),

  /** @returns {Promise<{ok:true}>} */
  logout: () => api.post("/auth/logout").then((r) => r.data),

  /** @returns {Promise<{ok:true}>} */
  refresh: () => api.post("/auth/refresh").then((r) => r.data),

  /**
   * @param {"en"|"es"} language
   * @returns {Promise<{language:string}>}
   */
  setLanguage: (language) =>
    api.put("/preferences/language", { language }).then((r) => r.data),
  changePassword: (current_password, new_password) =>
    api.post("/auth/change-password", { current_password, new_password }).then((r) => r.data),
  changeEmail: (new_email, current_password) =>
    api.post("/auth/change-email", { new_email, current_password }).then((r) => r.data),
};
